import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Combobox, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IKeywordGroup } from "app/pages/digital-marketing/common/hooks/useKeywordGroups";

interface IKeywordGroupSectionProps {
    disabledIds: Set<string>;
    title: string;
    groups: IKeywordGroup[];
    selectedItems: Set<string>;
    onToggle: (groupId: string) => void;
    disabledTooltipContent?: string;
}

export const KeywordGroupSection = ({
    title,
    groups,
    selectedItems,
    onToggle,
    disabledIds,
    disabledTooltipContent,
}: IKeywordGroupSectionProps) => {
    if (groups.length === 0) {
        return null;
    }

    return (
        <Combobox.Section>
            <Combobox.SectionHeader>{title}</Combobox.SectionHeader>
            {groups.map((group) => {
                const isDisabled = disabledIds.has(group.Id);

                return (
                    <Combobox.Option
                        key={group.Id}
                        value={group}
                        isDisabled={isDisabled}
                        onClick={() => onToggle(group.Id)}
                    >
                        <Tooltip
                            enabled={isDisabled}
                            content={disabledTooltipContent}
                        >
                            <Flex
                                gap="8px"
                                alignItems="center"
                            >
                                <SWReactIcons
                                    iconName="keyword-group"
                                    size="sm"
                                    iconColor={colorsPalettes.carbon["400"]}
                                />
                                <Combobox.OptionLabel>{group.Name}</Combobox.OptionLabel>
                            </Flex>
                        </Tooltip>
                        <Combobox.OptionCheckbox isChecked={selectedItems.has(group.Id) || isDisabled} />
                    </Combobox.Option>
                );
            })}
        </Combobox.Section>
    );
};
